import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ToTop",
  "use": "icon-ToTop-usage",
  "viewBox": "0 0 1231 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1231 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-ToTop\"><path d=\"M477.532569 273.339052V0.408579L0.006384 478.036908 477.532569 955.869526v-279.876309c341.163092 0 580.079401 109.090474 750.558803 348.006783-68.130474-341.163092-272.930474-682.326185-750.558803-750.763092\" fill=\"#967ADC\" p-id=\"12762\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol